import Channels from 'Chronos.Channels';

export default new Channels();
